import { ProductFormulaSectionItem } from 'components/sections/ProductFormulaSection'
import { NorthEastArrowCircle } from 'components/svg/NorthEastArrowCircle'

export const hairPlusIngredients: ProductFormulaSectionItem[] = [
  {
    title: 'Vitamina A',
    img: <NorthEastArrowCircle color="phthalo" />
  },
  {
    title: 'Vitamina B2',
    img: <NorthEastArrowCircle color="phthalo" />
  },
  {
    title: 'Vitamina B3',
    img: <NorthEastArrowCircle color="phthalo" />
  },
  {
    title: 'Vitamina B5',
    img: <NorthEastArrowCircle color="phthalo" />
  },
  {
    title: 'Biotina',
    img: <NorthEastArrowCircle color="phthalo" />
  },
  {
    title: 'Vitamina C',
    img: <NorthEastArrowCircle color="phthalo" />
  },
  {
    title: 'Vitamina D3',
    img: <NorthEastArrowCircle color="phthalo" />
  },
  {
    title: 'Vitamina E',
    img: <NorthEastArrowCircle color="phthalo" />
  },

  {
    title: 'Cobre',
    img: <NorthEastArrowCircle color="phthalo" />
  },
  {
    title: 'Selênio',
    img: <NorthEastArrowCircle color="phthalo" />
  },
  {
    title: 'Zinco',
    img: <NorthEastArrowCircle color="phthalo" />
  }
]
